module.exports = __webpack_public_path__ + "img/health_bad.45d269d6.svg";